'use client';

import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import CourseActionButton from './CourseActionButton';
type Props = {
  status: {
    isFinished: boolean;
    hasAlreadyFollowed: boolean;
    isNotStarted: boolean;
    isFollowing: boolean;
  };
  userId?: number;
};
export default function HeroAction(t0) {
  const $ = _c(17);
  const {
    status,
    userId
  } = t0;
  const {
    isFinished,
    hasAlreadyFollowed,
    isNotStarted,
    isFollowing
  } = status;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== hasAlreadyFollowed || $[2] !== isFinished || $[3] !== userId) {
    t2 = !isFinished && hasAlreadyFollowed && userId && <CourseActionButton action="follow" userId={userId} />;
    $[1] = hasAlreadyFollowed;
    $[2] = isFinished;
    $[3] = userId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isFinished || $[6] !== isNotStarted || $[7] !== userId) {
    t3 = !isFinished && isNotStarted && <Stack direction="row" alignItems="center"><Typography variant="subheading" component="span" sx={{
        display: {
          xs: "none",
          md: "block"
        }
      }}>{translate("course.header.incentive")}</Typography><Box sx={{
        ml: {
          xs: "auto",
          sm: "revert",
          md: 3
        },
        mr: "auto"
      }}><CourseActionButton action="start" userId={userId} /></Box></Stack>;
    $[5] = isFinished;
    $[6] = isNotStarted;
    $[7] = userId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isFinished || $[10] !== isFollowing || $[11] !== userId) {
    t4 = !isFinished && isFollowing && userId && <Stack direction={{
      xs: "column",
      sm: "row"
    }} alignItems="center" gap={1}><CourseActionButton action="continue" userId={userId} /><CourseActionButton action="unfollow" userId={userId} /></Stack>;
    $[9] = isFinished;
    $[10] = isFollowing;
    $[11] = userId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <Box sx={t1}>{t2}{t3}{t4}</Box>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}